export const mockResources = [
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'IpsComponent',
    type: 'PAGE',
    data: {
      route: 'admin/ips',
      component: 'dynamicDatalist',
      content: {
        title: 'IP addresses',
        dataUrl: '/v1/admin/users/',
        cols: [
          {
            type: 'text',
            title: 'VRM',
          },
          {
            type: 'clickable',
            icon: 'files_single-copy-04',
            overrideText: 'BO_VIEW',
            actionType: 'navigateToRoute',
            actionParameters: ['mz', 'decision', '{userId}'],
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'UsersComponent',
    type: 'PAGE',
    data: {
      route: 'admin/users',
      component: 'dynamicDatalist',
      content: {
        title: 'Users',
        dataUrl: '/v1/admin/users/',
        cols: [
          {
            type: 'text',
            propertyNames: ['firstname', 'lastname'],
            separator: ' ',
            title: 'BO_NAME',
          },
          {
            type: 'text',
            propertyNames: ['lastLogin'],
            title: 'BO_LAST_LOGIN',
            class: 'text-nowrap',
            format: 'yyyy-MM-dd HH:mm',
          },
          {
            type: 'text',
            propertyNames: ['organization'],
            title: 'BO_IP',
            class: 'text-nowrap',
          },
          {
            type: 'text',
            propertyNames: ['ip'],
            title: 'BO_IP',
            class: 'text-nowrap',
          },
          {
            type: 'clickable',
            icon: 'ui-1_settings-gear-63',
            actionType: 'navigateToRoute',
            actionParameters: ['admin', 'user', '{userId}'],
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'ClaimSummaryHoldComponent',
    type: 'PAGE',
    data: {
      route: 'lists/claims/summary',
      component: 'dynamicDatalist',
      content: {
        title: 'Passages on hold',
        dataUrl: '/v1/datalists/claims/summary/?isonhold=true',
        cols: [
          {
            type: 'text',
            title: '',
            class: 'text-nowrap',
            format: 'yyyy-MMM',
            propertyNames: ['date'],
          },
          {
            type: 'clickable',
            class: 'text-right',
            propertyNames: ['valueTotal'],
            actionType: 'navigateToListsClaimsList',
            actionParameters: ['{date}'],
          },
          {
            type: 'text',
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'ClaimListComponent',
    type: 'PAGE',
    data: {
      route: 'lists/claims/list/:year/:month',
      component: 'dynamicDatalist',
      content: {
        title: 'Passages on hold',
        dataUrl:
          '/v1/datalists/claims/?year={year}&month={month}&isonhold=true',
        cols: [
          {
            type: 'clickable',
            title: '',
            class: 'text-nowrap',
            format: 'yyyy-MM-dd',
            propertyNames: ['claimDate'],
            actionType: 'navigateToRoute',
            actionParameters: ['claims', 'claim', '{claimId}'],
          },
          {
            type: 'text',
            propertyNames: ['npId'],
          },
          {
            type: 'clickable',
            title: '',
            class: 'text-left',
            propertyNames: ['nameMasked'],
            actionType: 'navigateToEntity',
            actionParameters: ['{entityId}', true],
          },
          {
            type: 'text',
            propertyNames: ['text'],
            class: 'mxw-600',
          },
          {
            type: 'text',
            overrideText: ' ',
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'TaskListComponent',
    type: 'PAGE',
    data: {
      route: 'esb/tasks',
      component: 'dynamicDatalist',
      content: {
        title: 'Scheduled tasks',
        dataUrl: '/v1/esb/tasks',
        cols: [
          {
            type: 'clickable',
            title: '',
            class: 'mxw-600',
            propertyNames: ['description'],
            actionType: 'navigateToRoute',
            actionParameters: ['esb', 'task', '{taskId}'],
          },
          {
            type: 'text',
            overrideText: ' ',
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'MzListComponent',
    type: 'PAGE',
    data: {
      route: 'mz/violations',
      component: 'dynamicDatalist',
      content: {
        title: 'MZ_DECISIONS',
        dataUrl: '/v1/datalists/mzpending',
        cols: [
          {
            type: 'text',
            title: 'BO_DATE',
            class: 'text-nowrap',
            format: 'yyyy-MM-dd',
            propertyNames: ['date'],
          },
          {
            type: 'clickable',
            propertyNames: ['value1'],
            title: 'Pending',
            class: 'cell-link-block',
            actionType: 'navigateToMzPending',
            actionParameters: ['{value1}'],
          },
          {
            type: 'clickable',
            title: 'On hold',
            propertyNames: ['value2'],
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'MzSummaryComponent',
    type: 'PAGE',
    data: {
      route: 'mz/summary',
      component: 'dynamicDatalist',
      content: {
        title: 'BO_SUMMARY',
        dataUrl: '/v1/datalists/mzpending/claims/summary',
        cols: [
          {
            type: 'text',
            propertyNames: ['type'],
            translate: true,
          },
          {
            type: 'clickable',
            propertyNames: ['count'],
            actionType: 'navigateToMzDecisionsPending',
            actionParameters: ['{type}'],
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'UnpaidSummaryComponent',
    type: 'PAGE',
    data: {
      route: 'reporting/unpaid',
      component: 'dynamicDatalist',
      content: {
        title: 'Unpaid',
        dataUrl: '/v1/datalists/claims/unpaidpercountry/?statusid=15',
        cols: [
          {
            type: 'text',
            title: 'Country',
            propertyNames: ['string1'],
            class: 'text-left',
          },
          {
            type: 'text',
            title: 'Toll',
            propertyNames: ['value1'],
            class: 'text-right',
          },
          {
            type: 'text',
            title: 'TIN',
            propertyNames: ['value2'],
            class: 'text-right',
          },
          {
            type: 'text',
            title: 'RN1',
            propertyNames: ['value3'],
            class: 'text-right',
          },
          {
            type: 'text',
            title: 'RN2',
            propertyNames: ['value4'],
            class: 'text-right',
          },
          {
            type: 'text',
            title: 'Total',
            propertyNames: ['valueTotal'],
            class: 'text-right',
          },
          {
            type: 'text',
            title: 'Count',
            propertyNames: ['value7'],
            class: 'text-right',
          },
          {
            type: 'text',
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'PricesComponent',
    type: 'PAGE',
    data: {
      route: 'system/prices',
      component: 'dynamicDatalist',
      content: {
        title: 'BO_LEZ_RULES',
        dataUrl: '/v1/system/lezlogics',
        cols: [
          {
            type: 'text',
            propertyNames: ['startDate'],
            format: 'yyyy-MM-dd',
            class: 'text-nowrap',
          },
          {
            type: 'text',
            propertyNames: ['endDate'],
            format: 'yyyy-MM-dd',
            class: 'text-nowrap',
          },
          {
            type: 'text',
            class: 'w-100',
            propertyNames: ['criteria'],
          },
          {
            type: 'text',
            propertyNames: 'price',
            class: 'w-100 text-right pr5',
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'WorkOrdersSummaryComponent',
    type: 'PAGE',
    data: {
      route: 'workorders/summary',
      component: 'dynamicDatalist',
      content: {
        title: 'BO_SUMMARY',
        dataUrl: '/v1/workorders/',
        wrapperClass: 'container-extended views-container',
        cols: [
          {
            type: 'text',
            propertyNames: ['messageDate'],
            format: 'yyyy-MM-dd',
            title: 'BO_DATE',
            class: 'text-nowrap',
          },
          {
            type: 'text',
            overrideText: 'WORKORDER',
          },
          {
            type: 'text',
            propertyNames: ['label'],
          },
          {
            type: 'clickable',
            overrideText: 'BO_VIEW',
            icon: 'files_single-copy-04',
            actionType: 'navigateToDeicisionOrSearch',
            actionParameters: ['{id}'],
          },
        ],
      },
    },
  },
  {
    id: '2a3ae9f8-4c0e-4914-ab07-fc78c986b199',
    name: 'ListDynamicListsComponent',
    type: 'PAGE',
    data: {
      route: 'management/dynamiclists',
      component: 'dynamicDatalist',
      content: {
        title: 'BO_DYNAMIC_LISTS',
        dataUrl: '/v1/applications/resources/',
        wrapperClass: 'container-single views-container',
        cols: [
          {
            type: 'clickable',
            propertyNames: ['name'],
            title: 'BO_NAME',
            actionType: 'navigateToRoute',
            actionParameters: ['management', 'dynamiclists', 'edit', '{id}'],
          },
          {
            type: 'text',
            propertyNames: ['type'],
            title: 'BO_TYPE',
          },
        ],
      },
    },
  },
];
